import { render, staticRenderFns } from "./OverViewFinancials.vue?vue&type=template&id=a679fd24"
import script from "./OverViewFinancials.vue?vue&type=script&lang=js"
export * from "./OverViewFinancials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports